interface IInput {
    placeholder?: string;
    maxLength?: number;
}
interface IInputProps {
    defaultValue?: string;
    type?: string;
    className?: string;
    disabled?: boolean;
    onChange?: (value: string) => void;
    option: IInput;
}
interface ISearchProps {
    placeholder?: string;
    maxLength?: number;
    type?: string;
    className?: string;
    maxCount?: number;
    list?: IListItem[];
    disabled?: boolean;
    getList: (val: string) => Promise<IListItem[]>;
    selectList: IListItem[];
    renderData: (data: IListItem, num: number) => JSX.Element;
    renderChildren: (data: IListItem) => JSX.Element;
    onSelect: (data: IListItem) => void;
    style?: React.CSSProperties;
    overlayClassName?: string;
    offset?: [number, number];
}
interface IListItem {
    icon: string;
    title: string;
    label: string;
    id: string;
    type: number;
}
enum MEMBER_TYPE {
    USER = 'user',
    GROUP = 'group',
    DEPARTMENT = 'department',
    CLASS = 'class',
}

enum MEMBER_ID_TYPE {
    USER = 'umu_id',
    GROUP = 'user_group_id',
    DEPARTMENT = 'id',
    CLASS = 'class_id',
}

enum MEMBER_ASSESSMENT_TYPE {
    CLASS = 3, // 班级
    DEPART = 2, // 部门
    GROUP = 1, // 分组
    MEMBER = 0, // 成员
}
type IMemberMAP = {
    [propName in MEMBER_TYPE]: MEMBER_ASSESSMENT_TYPE;
};
type IUserTypeMAP = {
    [propName in MEMBER_ASSESSMENT_TYPE]: MEMBER_TYPE;
};
type IMemberIdMap = {
    [propName in MEMBER_ASSESSMENT_TYPE]: MEMBER_ID_TYPE;
};
interface IParams {
    id: string;
    title: string;
    icon: string;
    label: string;
    type: MEMBER_ASSESSMENT_TYPE;
    assignId?: string;
    account_type?: string;
}
enum SEARCH_DIR {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center',
    TOP = 'top',
}
interface IProps {
    isUseV2?: boolean;
    searchSource?: string;
    placeholder: string;
    limitMax?: number;
    isClear?: boolean;
    disabled?: boolean;
    selectList?: IParams[];
    extraParams?: { [key: string]: any };
    onChange?: (item: string[], list?: IParams[]) => void;
    disabledCallBack?: () => void;
    style?: React.CSSProperties;
    overlayClassName?: string;
    offset?: [number, number];
}
export {
    IProps,
    IParams,
    IInput,
    SEARCH_DIR,
    IMemberMAP,
    IInputProps,
    ISearchProps,
    IListItem,
    MEMBER_TYPE,
    IUserTypeMAP,
    MEMBER_ASSESSMENT_TYPE,
    MEMBER_ID_TYPE,
    IMemberIdMap,
};
